/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Createaccounttitle2Inputs */

const zh_auth_createaccounttitle2 = /** @type {(inputs: Auth_Createaccounttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建账户`)
};

const en_auth_createaccounttitle2 = /** @type {(inputs: Auth_Createaccounttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const es_auth_createaccounttitle2 = /** @type {(inputs: Auth_Createaccounttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una cuenta`)
};

/**
* | output |
* | --- |
* | "Create an account" |
*
* @param {Auth_Createaccounttitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_createaccounttitle2 = /** @type {((inputs?: Auth_Createaccounttitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Createaccounttitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_createaccounttitle2(inputs)
	if (locale === "en") return en_auth_createaccounttitle2(inputs)
	return es_auth_createaccounttitle2(inputs)
});
export { auth_createaccounttitle2 as "auth_createAccountTitle" }